import KnownActionDetailPage from './KnownActionDetailPage';

export default KnownActionDetailPage;